import { Box, Button, Card, CardContent, Grid, Typography } from '@mui/material'
import React from 'react'

export interface Cards1Props {
  title?: string;
  cards: [
    {
      iconoCard?: string;
      title?: string;
      tituloBoton?: string;
      urlBoton?: string;
      text?: any;
    }
  ];
}

const Cards1 = ({title, cards}: Cards1Props) => {
    return (
        <Grid container spacing={2} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop:16, background:'#F6F8FF'}} id={title}>
          <Grid item xs={10} style={{padding:4, marginTop:'6rem', marginBottom:'6rem'}}>
            <Grid item xs={12} style={{padding:4, margin:4, marginTop:'40px', marginBottom:'30px'}}>
              <Typography variant="h4" component='h2' color="initial" style={{fontWeight:700, fontSize:'47px'}}>
                {title}
              </Typography>
            </Grid>
            <Grid container spacing={2} style={{ padding: 6 }}>
              {cards?.map((card, index) =>{
                return (
                  <Grid item xs={12} sm={6} md={4} key={index} style={{display:'flex', justifyContent:'center', alignItems:'center'}}>
                      <Card square={false} elevation={4} key={index} style={{width:'343px',minWidth:'343px', maxWidth:'343px', minHeight:'439px',maxHeight:'439px', height:'439px'}}>
                        <Box style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', padding: 8, background:'#FCE3ED', width:'70px', height:'70px', borderRadius:5, margin:10 }}>
                          <i className={card.iconoCard} style={{ color: '#EE2B7B', fontSize: '50px' }}></i>
                        </Box>
                        <CardContent style={{height:'260px', display:'flex', flexDirection:'column', justifyContent:'space-between'}}>
                            <Typography variant="h6" component='h6' color="initial" style={{ fontSize: '33px', marginTop:'16px' }}>
                              <strong>{card.title}</strong>
                            </Typography>
                            <Typography variant="body2" color="initial" style={{overflow: 'hidden', textOverflow: 'ellipsis', display: '-webkit-box', WebkitLineClamp: 3, WebkitBoxOrient: 'vertical', fontWeight: 400, fontSize:'16px'}}>
                          {card.text[0]}
                          </Typography>
                        </CardContent>
                        <CardContent style={{height:'30px'}}>
                            <Button 
                              variant="contained" 
                              href={card.urlBoton} 
                              style={{ 
                              backgroundColor: `${card.tituloBoton != 'Próximamente' ? '#EE2B7B' : '#CFCFCF' }`, 
                              color: `${card.tituloBoton != 'Próximamente' ? 'white' : '#737373' }`, 
                              borderRadius: '20px',
                              textTransform: 'none'
                               }}
                               disabled={card.tituloBoton === 'Próximamente'} >
                            {card.tituloBoton}
                            </Button>
                        </CardContent>
                      </Card>
                  </Grid>
                )
              })}
            </Grid>
          </Grid>
        </Grid>
      )
}    

export default Cards1
